package com.example.crashbit

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp

@Composable
fun LanguageSelectionScreen(viewModel: SpaceViewModel) {
    val languages = listOf(
        "English" to "en",
        "Español" to "es",
        "日本語" to "ja",
        "Français" to "fr",
        "Deutsch" to "de",
        "हिन्दी" to "hi",
        "简体中文" to "zh",
        "Português" to "pt",
        "Русский" to "ru",
        "한국어" to "ko",
        "Italiano" to "it",
        "বাংলা" to "bn",
        "Türkçe" to "tr",
        "Bahasa Indonesia" to "id",
        "Tiếng Việt" to "vi",
        "Polski" to "pl"
    )

    Box(
        modifier = Modifier
            .fillMaxSize()
            .background(Color.Black)
    ) {
        CelestialDanceBackground(scrollOffset = 0, interactiveParticles = emptyList())

        Column(
            modifier = Modifier
                .fillMaxSize()
                .padding(32.dp)
                .verticalScroll(rememberScrollState()),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Center
        ) {
            Text(
                text = "CELESTIAL FIDGET",
                color = Color.Yellow,
                fontSize = 32.sp,
                fontWeight = FontWeight.ExtraBold,
                letterSpacing = 4.sp,
                textAlign = TextAlign.Center
            )

            Spacer(modifier = Modifier.height(8.dp))

            Text(
                text = "Choose Your Language",
                color = Color.White.copy(alpha = 0.6f),
                fontSize = 16.sp,
                fontWeight = FontWeight.Bold,
                textAlign = TextAlign.Center
            )

            Spacer(modifier = Modifier.height(48.dp))

            languages.chunked(2).forEach { row ->
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.spacedBy(16.dp)
                ) {
                    row.forEach { (name, code) ->
                        LanguageButton(
                            name = name,
                            isSelected = viewModel.languageCode == code,
                            modifier = Modifier.weight(1f)
                        ) {
                            viewModel.selectLanguage(code)
                        }
                    }
                }
                Spacer(modifier = Modifier.height(16.dp))
            }
        }
    }
}

@Composable
fun LanguageButton(
    name: String,
    isSelected: Boolean,
    modifier: Modifier = Modifier,
    onClick: () -> Unit
) {
    Button(
        onClick = onClick,
        modifier = modifier.height(56.dp),
        colors = ButtonDefaults.buttonColors(
            containerColor = if (isSelected) Color.Cyan.copy(alpha = 0.3f) else Color.White.copy(alpha = 0.1f),
            contentColor = if (isSelected) Color.Cyan else Color.White
        ),
        shape = RoundedCornerShape(12.dp),
        border = androidx.compose.foundation.BorderStroke(
            1.dp, 
            if (isSelected) Color.Cyan else Color.White.copy(alpha = 0.2f)
        )
    ) {
        Text(
            text = name,
            fontSize = 16.sp,
            fontWeight = FontWeight.Bold
        )
    }
}
